import React, { FC } from 'react'

import { IconTrackisafeProps } from './IconTrackisafe.types'
import * as Styled from './styles/IconTrackisafe.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTrackisafe: FC<IconTrackisafeProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTrackisafeProps['size'],
  isResponsive = false,
}: IconTrackisafeProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M23.93 6.363c7.722-.008 13.992 6.246 14 13.969v.016c0 9.28-13.938 21.289-13.938 21.289S10.07 29.57 10.07 20.289c0-7.695 6.239-13.93 13.93-13.926'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M19.484 28.063a.518.518 0 0 1-1.035 0 .518.518 0 0 1 1.035 0Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M19.125 28.063c0 .085-.07.156-.156.156-.09 0-.16-.07-.16-.157 0-.085.07-.156.16-.156.086 0 .156.07.156.157Zm5.391 0a.515.515 0 1 1-1.03 0 .515.515 0 0 1 1.03 0Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.156 28.063c0 .085-.07.156-.156.156a.157.157 0 0 1-.156-.157c0-.085.07-.156.156-.156s.156.07.156.157Zm5.394 0a.518.518 0 0 1-1.034 0 .518.518 0 0 1 1.035 0Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.191 28.063c0 .085-.07.156-.16.156a.157.157 0 0 1-.156-.157c0-.085.07-.156.156-.156.09 0 .16.07.16.157Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTrackisafe
